import { Resizable } from './dist/resizable';
export {
    Resizable,
};
